/*
  Application Login Page
*/

import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Antd
import { Form, Button, Input } from "antd";

// Redux
import { useDispatch, } from "react-redux";

// Components
import AuthenticationBase from "..";

//ACTIONS
import { updatePatchRequest } from "../../../store/actions/CRUDAction";

// Helper
import {
  successNotification,
} from "../../../helpers/Notification";
import { getConfirmPasswordError } from "../../../helpers/AuthHelper";

// Constants
import { API_URLS } from "../../../constants/ApiUrl";
import APP_URL from "../../../constants/ApplicationUrls";

// Localization
import LOCALIZATION from "../../../services/LocalizationService";

function Login(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  let formRef = React.createRef();

  const { uid, token } = useParams();

  const [loading, setloading] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const onSubmit = (data) => {
    data["uid"] = uid;
    data["token"] = token;
    seterrorMessage("");
    setloading(true);
    dispatch(
      updatePatchRequest(API_URLS.PASSWORD_RESET_CONFIRM, data, {}, {})
    ).then(
      (response) => {
        form.resetFields();
        successNotification(response.data.message);
        navigate(APP_URL.AUTH.LOGIN);
        setloading(false);
      },
      (e) => {
        seterrorMessage(getConfirmPasswordError(e, LOCALIZATION.INTERNAL_SERVER_ERROR_MESSAGE));
        form.resetFields();
        setloading(false);
      }
    );
  };

  return (
    <AuthenticationBase loading={loading}>
      <div className="app-logo">
        <h1>New Password</h1>
      </div>

      <Form form={form} ref={formRef} onFinish={onSubmit} layout="vertical">
        <Form.Item
          className="form-group"
          name="password"
          label={LOCALIZATION.NEW_PASSWORD}
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
          hasFeedback
        >
          <Input.Password className="form-control"/>
        </Form.Item>

        <Form.Item
          className="form-group"
          name="confirm_password"
          label={LOCALIZATION.NEW_PASSWORD_CONFIRM}
          dependencies={["password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: "Please confirm your password!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Password not match"));
              },
            }),
          ]}
        >
          <Input.Password className="form-control"/>
        </Form.Item>
        {!!errorMessage && <h4 style={{ color: "red" }}>{errorMessage}</h4>}
        <Form.Item>
          <Button
            block
            size="large"
            type="primary"
            htmlType="submit"
            className="mt-3"
          >
            {LOCALIZATION.CONFIRM_PASSWORD}
          </Button>
        </Form.Item>
      </Form>
    </AuthenticationBase>
  );
}

export default Login;
